import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { IMenu } from 'src/app/domain/IMenu';
import { IAction } from 'src/app/domain/IAction';

@Injectable({
  providedIn: 'root',
})
export class BarService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Retorna a lista completa de menus do arquivo menu.json
   */
  public getList(): Observable<IMenu[]> {
    return this.httpClient.get<IMenu[]>('assets/menu.json').pipe(
      catchError((error) => throwError(error))
    );
  }

  /**
   * Retorna a lista de menus para a barra de navegação,
   * excluindo os itens marcados como onlyInCards
   */
  public getNavbarMenus(): Observable<IMenu[]> {
    return this.httpClient.get<IMenu[]>('assets/menu.json').pipe(
      map((items: IMenu[]) => {
        // Filtra os menus que NÃO devem aparecer na barra principal
        return items.filter(item => !item.onlyInCards);
      }),
      catchError((error) => throwError(error))
    );
  }

  /**
   * Retorna a lista de menus que devem aparecer apenas como cards
   */
  public getCardMenus(): Observable<IMenu[]> {
    return this.httpClient.get<IMenu[]>('assets/menu.json').pipe(
      map((items: IMenu[]) => {
        // Retorna apenas os menus que devem aparecer como cards
        return items.filter(item => item.onlyInCards === true);
      }),
      catchError((error) => throwError(error))
    );
  }

  /**
   * Retorna todas as ações do sistema
   */
  getSystemActions(): Observable<IAction[]> {
    return this.httpClient.get<IAction[]>('assets/system-actions.json');
  }
}
